import 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import {LangProvider} from '@cloudaper/react';
import './index.css';
import App from './App';

var cssLink = document.createElement('link');
cssLink.setAttribute('rel', 'stylesheet');
cssLink.setAttribute('type', 'text/css');
cssLink.setAttribute('href', './App.css');
document.querySelector('head').appendChild(cssLink);

ReactDOM.render(
  <React.StrictMode>
    <LangProvider lang="cs">
      <App />
    </LangProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
